import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import uuid from '../../utils/uuid.js';
import Grid from '../Grid.js';

var _excluded = ["children", "className", "disabled", "error", "required", "rightContent"];

// LABEL
var InputLabel = function InputLabel(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    required = _ref.required,
    rightContent = _ref.rightContent,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Input--type-label', {
    isDisabled: disabled,
    isErrored: error,
    isRequired: required
  }, className);
  var uniqueID = uuid();
  if (rightContent) {
    return /*#__PURE__*/React.createElement(Grid.Container, {
      align: "flex-end",
      role: "group",
      "aria-labeledby": uniqueID
    }, /*#__PURE__*/React.createElement(Grid.Item, {
      xs: true
    }, /*#__PURE__*/React.createElement("label", _extends({
      id: uniqueID,
      className: finalClasses
    }, otherProps), children, required && /*#__PURE__*/React.createElement("span", {
      className: "C-Input--type-label__Required"
    }, "*"))), /*#__PURE__*/React.createElement(Grid.Item, {
      className: finalClasses
    }, rightContent));
  } else {
    return /*#__PURE__*/React.createElement("label", _extends({
      className: finalClasses
    }, otherProps), children, required && /*#__PURE__*/React.createElement("span", {
      className: "C-Input--type-label__Required"
    }, "*"));
  }
};
InputLabel.displayName = 'Input.Label';

export { InputLabel as default };
